// ═══════════════════════════════════════════════════════════════════════════
// Los primeros pasos de quien acaba de entrar con un ticket
//
// DOS PROBLEMAS QUE SE RESUELVEN EN EL MISMO MOMENTO, y por eso están juntos.
//
// 1 · «Saber qué vendedor es cuál». Hasta ahora el alta por dispositivo solo
//     capturaba el nombre del APARATO ("iPhone · Safari"), así que en la lista
//     del equipo el dueño veía aparatos, no personas.
//
// 2 · «Qué pasa si cambia de teléfono o se borra el caché». La sesión vive en
//     el navegador: si se va, se va el acceso, y hoy la única salida es pedirle
//     otro ticket al jefe. La llave de acceso lo arregla —se comprobó que un
//     usuario-dispositivo puede generar la suya y volver a entrar con ella desde
//     un navegador limpio— pero de nada sirve si nadie le dice que existe.
//
// POR QUÉ AQUÍ Y NO EN «MI CUENTA». Las dos cosas ya se podían hacer desde Mi
// cuenta, y nadie las hacía. Este es el único instante en que la persona está
// mirando la pantalla a propósito, entendiendo que está dándose de alta. Diez
// minutos después está levantando un pedido y no va a ir a buscar una sección
// que no sabe que existe.
//
// LA LLAVE EXIGE UN ACUSE. No hay «continuar» hasta que dice que la guardó. Es
// deliberado y es la única fricción que se agrega: una llave que se enseña y se
// pasa de largo es exactamente igual a no tenerla, y no se puede volver a ver.
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState } from "react";
import { crearLlave } from "./llaves.js";
import { guardarMiPerfil } from "../datos/vendedores.js";
import { LOGO_BASE64 } from "../pdf/logo.js";
import { btnPrimary, btnSecondary, inputStyle } from "../ui/estilos.js";

export function PrimerosPasos({ sesion, tenant, onListo }) {
  const [paso, setPaso] = useState("datos");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [llave, setLlave] = useState(null);
  const [guardada, setGuardada] = useState(false);
  const [copiada, setCopiada] = useState(false);
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState("");

  const seguir = async () => {
    setOcupado(true); setError("");
    try {
      await guardarMiPerfil(sesion.user.id, {
        full_name: nombre.trim(),
        ...(telefono.trim() ? { phone: telefono.trim() } : {}),
      });
      // La llave se pide DESPUÉS de guardar el nombre: si algo falla aquí, no
      // se quema una llave que ya no se puede volver a mostrar.
      setLlave(await crearLlave(`Respaldo de ${nombre.trim()}`));
      setPaso("llave");
    } catch (e) { setError(e.message); }
    setOcupado(false);
  };

  const copiar = () => {
    navigator.clipboard?.writeText(llave.llave);
    setCopiada(true);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center",
                  justifyContent: "center", background: "#0a0a0a", padding: 20 }}>
      <div style={{ maxWidth: 420, width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <img src={LOGO_BASE64} alt="" style={{ width: 56, height: 56, objectFit: "contain" }} />
        </div>

        {paso === "datos" ? (
          <>
            <div style={{ fontSize: 11, color: "#a8d060", letterSpacing: 2, marginBottom: 8 }}>
              YA ESTÁS DENTRO{tenant ? ` DE ${tenant.toUpperCase()}` : ""}
            </div>
            <div style={{ fontSize: 15, color: "#e8e0d4", marginBottom: 18, lineHeight: 1.6 }}>
              Faltan dos cosas rápidas y no te las volvemos a pedir.
            </div>

            <label style={{ display: "block", fontSize: 10, color: "#666",
                            letterSpacing: 1, marginBottom: 4 }}>
              TU NOMBRE
            </label>
            <input value={nombre} onChange={e => setNombre(e.target.value)}
              placeholder="Como quieres aparecer en el equipo"
              disabled={ocupado} maxLength={80} autoFocus
              style={{ ...inputStyle, width: "100%", marginBottom: 14 }} />

            <label style={{ display: "block", fontSize: 10, color: "#666",
                            letterSpacing: 1, marginBottom: 4 }}>
              TU TELÉFONO <span style={{ color: "#444" }}>· opcional</span>
            </label>
            <input value={telefono} onChange={e => setTelefono(e.target.value)}
              inputMode="tel" disabled={ocupado} maxLength={20}
              style={{ ...inputStyle, width: "100%", marginBottom: 6 }} />
            <div style={{ fontSize: 11, color: "#666", lineHeight: 1.6, marginBottom: 18 }}>
              Tus datos de banco, si cobras comisión, los pones después en
              «Mi cuenta» — ahí nadie más los ve.
            </div>

            <button onClick={seguir} disabled={ocupado || !nombre.trim()}
              style={{ ...btnPrimary, width: "100%", padding: "13px 18px", fontSize: 15,
                       opacity: (ocupado || !nombre.trim()) ? 0.4 : 1 }}>
              {ocupado ? "Un momento…" : "Continuar"}
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 11, color: "#c9a96e", letterSpacing: 2, marginBottom: 8 }}>
              GUARDA ESTA LLAVE
            </div>
            <div style={{ fontSize: 14, color: "#e8e0d4", marginBottom: 14, lineHeight: 1.6 }}>
              Si cambias de teléfono, o se borra la memoria del navegador, esta
              llave es lo que te deja volver a entrar sin pedirle nada a nadie.
            </div>

            <div style={{ fontFamily: "monospace", fontSize: 15, color: "#c9d8a0",
                          background: "#0d1108", border: "1px solid #2a3a1a",
                          borderRadius: 8, padding: "14px 12px", wordBreak: "break-all",
                          userSelect: "all", marginBottom: 10 }}>
              {llave?.llave}
            </div>

            <button onClick={copiar}
              style={{ ...btnSecondary, width: "100%", padding: "10px 16px", fontSize: 13,
                       borderColor: "#3a5a1a", color: "#a8d060", marginBottom: 16 }}>
              {copiada ? "✓ Copiada" : "Copiar la llave"}
            </button>

            <div style={{ padding: "12px 14px", background: "#1a1408",
                          border: "1px solid #3a331a", borderRadius: 8,
                          fontSize: 12, color: "#8a8266", lineHeight: 1.7, marginBottom: 16 }}>
              Anótala donde la vuelvas a encontrar: en tus notas, en un papel en
              la cartera, donde sea tuyo. <b style={{ color: "#facc15" }}>No se
              vuelve a mostrar</b> — ni nosotros la podemos ver. Si la pierdes, se
              genera otra desde «Mi cuenta».
            </div>

            <label style={{ display: "flex", gap: 10, alignItems: "flex-start",
                            fontSize: 13, color: "#aaa", cursor: "pointer",
                            marginBottom: 16 }}>
              <input type="checkbox" checked={guardada}
                onChange={e => setGuardada(e.target.checked)}
                style={{ marginTop: 3, width: 18, height: 18, accentColor: "#a8d060" }} />
              <span>Ya la guardé</span>
            </label>

            <button onClick={onListo} disabled={!guardada}
              style={{ ...btnPrimary, width: "100%", padding: "13px 18px", fontSize: 15,
                       opacity: guardada ? 1 : 0.4 }}>
              Entrar
            </button>
          </>
        )}

        {error && (
          <div style={{ marginTop: 14, padding: "10px 12px", background: "#1f0d0d",
                        border: "1px solid #3a1a1a", borderRadius: 8,
                        fontSize: 12, color: "#f87171" }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
}
